export default __webpack_public_path__ + "img/ico-star.e022091.svg";